// Wire enum values — English per api-contract §2. Slovenian labels come from i18n only.

export enum UserRole {
    SuperAdmin = 'super_admin',
    ProbeAdmin = 'probe_admin',
    User       = 'user',
    // v1.16: read-only "bookkeeping" role — sees and exports everyone's reports, nothing else.
    Reporter   = 'reporter',
}

export enum DeviceStatus {
    Active   = 'active',
    Inactive = 'inactive',
}

export enum ReservationStatus {
    Confirmed = 'confirmed',
    Pending   = 'pending',
    Cancelled = 'cancelled',
}

export enum QuotaRenewal {
    Weekly  = 'weekly',
    Monthly = 'monthly',
    Yearly  = 'yearly',
    Never   = 'never',
}

export enum NotificationType {
    Info    = 'info',
    Success = 'success',
    Warning = 'warning',
    Error   = 'error',
    Request = 'request',
}

// v1.13: what a notification is about (inbox filter), independent of its visual type.
export enum NotificationCategory {
    Reservation = 'reservation',
    ProbeChange = 'probe_change',
    Feedback    = 'feedback',
    Message     = 'message',
}

// v1.5: derived probe-change lifecycle.
export enum ProbeChangeStatus {
    Backlog = 'backlog',
    Todo    = 'todo',
    Done    = 'done',
}

// v1.7: why a reservation awaits admin confirmation.
export enum PendingReason {
    ProbeMismatch = 'probe_mismatch',
    OutsideWindow = 'outside_window',
}

export enum ClientType {
    Internal = 'internal',
    External = 'external',
}

export enum RecurrenceType {
    Daily   = 'daily',
    Weekly  = 'weekly',
    Monthly = 'monthly',
}

export enum SlotReason {
    Closed   = 'closed',
    Downtime = 'downtime',
    Occupied = 'occupied',
    Quota    = 'quota',
}

export enum NotificationTarget {
    All    = 'all',
    Groups = 'groups',
    Person = 'person',
}
